document.addEventListener("DOMContentLoaded", function () {

  const publicationSwiper = new Swiper(".js-publication-testimonial-swiper", {

    slidesPerView: 2,
    spaceBetween: 32,
    speed: 600,

    navigation: {
      nextEl: ".js-publication-testimonials-carousel-arrow-next",
      prevEl: ".js-publication-testimonials-carousel-arrow-prev",
    },

    autoplay: {
      delay: 5000, // 5 seconds
      disableOnInteraction: true, // keeps autoplay running after manual swipe
    },

    scrollbar: {
      el: ".publication-swiper-scrollbar",
      draggable: true
    },

    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 32
      }
    }

  });

});